import { vnModule_knockoutJS } from "@valnet/vnApp/vnModule_knockoutJS";
import { menuSidebar_template } from "~/components/templates/menuSidebar_template";
import { getMenusWithSelection } from "~/modules/menu_data";
import { store } from "~/state/store";
const SIDEBAR_DATA_ATTR = "data-sidebar";
const SIDEBAR_PREFER_COLLAPSE_DATA_ATTR = "data-sidebar-prefer-collapse";
const SIDEBAR_STATE = {
    hidden: "hidden",
    expanded: "expanded",
    collapsed: "collapsed",
};
export class menu_sidebar extends vnModule_knockoutJS {
    constructor() {
        super(...arguments);
        this.unsubscribeSidebarState = null;
    }
    getModuleName() {
        return "menu-sidebar";
    }
    buildContent() {
        const vnApp = this.getVnAppZone().app;
        if (vnApp.loggedUser?.isLoggedIn) {
            this.initializeSidebarState();
            this.sidebar = new menuSidebar_template("mainMenuSidebar", this.viewModel, this);
            this.sidebar.setMenus(getMenusWithSelection());
            this.bindSidebarState();
            return [this.sidebar.build()];
        }
        this.unsubscribeFromSidebarState();
        this.clearMainSidebarState();
        return [document.createElement("div")];
    }
    fillPage() {
        // no fill
    }
    cleanup() {
        this.unsubscribeFromSidebarState();
    }
    initializeSidebarState() {
        store.getState().initializeSidebar(this.getDefaultSidebarOpenState());
    }
    bindSidebarState() {
        this.unsubscribeFromSidebarState();
        this.unsubscribeSidebarState = store.subscribe((state) => state.isSidebarOpen, (isOpen) => {
            this.setMainSidebarState(isOpen);
            this.sidebar?.setSidebarState(isOpen);
        }, { fireImmediately: true });
    }
    unsubscribeFromSidebarState() {
        this.unsubscribeSidebarState?.();
        this.unsubscribeSidebarState = null;
    }
    getDefaultSidebarOpenState() {
        const appMain = this.getAppMain();
        if (!appMain) {
            return true;
        }
        const sidebarState = appMain.getAttribute(SIDEBAR_DATA_ATTR);
        return sidebarState !== SIDEBAR_STATE.collapsed;
    }
    setMainSidebarState(isOpen) {
        const appMain = this.getAppMain();
        if (!appMain) {
            return;
        }
        appMain.setAttribute(SIDEBAR_DATA_ATTR, isOpen
            ? SIDEBAR_STATE.expanded
            : SIDEBAR_STATE.collapsed);
        appMain.toggleAttribute(SIDEBAR_PREFER_COLLAPSE_DATA_ATTR, !isOpen);
    }
    clearMainSidebarState() {
        const appMain = this.getAppMain();
        if (!appMain) {
            return;
        }
        appMain.setAttribute(SIDEBAR_DATA_ATTR, SIDEBAR_STATE.hidden);
        appMain.removeAttribute(SIDEBAR_PREFER_COLLAPSE_DATA_ATTR);
    }
    getAppMain() {
        return document.querySelector(".app-main");
    }
}
